var map = {
	"./AnahitaElec.jpg": 6248,
	"./AnahitaSoft.jpg": 4603,
	"./anahita-3.jpg": 2199,
	"./anahita-underwater.png": 1029,
	"./anahita-underwater2.png": 3744,
	"./anahita_exploded.png": 8841,
	"./battery.png": 5866,
	"./camera.png": 1080,
	"./conandpen.png": 4197,
	"./cv.png": 2470,
	"./frame.png": 5314,
	"./gabber.png": 240,
	"./header_06.png": 1353,
	"./hull.png": 8752,
	"./hydrophones.jfif": 6771,
	"./imu.png": 5642,
	"./markerdropper.png": 4319,
	"./mechmain.png": 3165,
	"./objdetection.png": 1441,
	"./pneumatic.png": 3983,
	"./powermgmt.png": 8337,
	"./sensors.png": 5292,
	"./torpedo.png": 2024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7041;